/**
 * Converts a raw wallet/viem/on-chain error into a short user-friendly string
 * displayed in the trading panel.
 *
 * Extracted here so it can be unit-tested without rendering any React component.
 */
export function friendlyError(e: unknown): string {
  const msg = e instanceof Error ? e.message : String(e);
  if (
    msg.includes("User rejected") ||
    msg.includes("4001") ||
    msg.includes("denied") ||
    msg.includes("user rejected") ||
    msg.includes("cancelled")
  ) {
    return "Transaction cancelled.";
  }
  // Simulation / on-chain revert reasons from BondingCurveMarket.sol
  if (msg.includes("Market: graduated")) {
    return "This market has graduated — bonding curve trading is closed.";
  }
  if (msg.includes("Market: paused")) {
    return "This market is temporarily paused by the protocol.";
  }
  if (
    msg.includes("Market: slippage") ||
    msg.includes("slippage") ||
    msg.includes("Slippage")
  ) {
    return "Price moved too much — try a smaller amount or retry.";
  }
  if (
    msg.includes("Market: deadline") ||
    msg.includes("deadline") ||
    msg.includes("Deadline")
  ) {
    return "Transaction deadline expired — please retry.";
  }
  if (msg.includes("insufficient") || msg.includes("Insufficient")) {
    return "Insufficient balance.";
  }
  return msg.slice(0, 200);
}
